export const DEFERED_BASE_COLOR = '#E67300'
export const CREDIT_TO_BANK_BASE_COLOR = '#DA291C'
export const GRAPH_CURRENT_PERIOD_COLOR = '#FCB314'
export const GRAPH_REVENUE_COLOR = '#E15449'
export const GRAPH_REVENUE_HIGHLIGHT_COLOR = '#E97F77'
export const GRAPH_SALES_COLOR = '#EA8E33'
export const GRAPH_SALES_AREA_COLOR = '#FAE3CC'
export const GRAPH_CURRENT_PERIOD_CARDS_COLOR = '#FDC343'
export const GRAPH_PREVIOUS_PERIOD_COLOR = '#AFAFAF'
export const GRAPH_PREVIOUS_PERIOD_HIGHLIGHT_COLOR = '#D7D7D7'
export const GRAPH_PREVIOUS_PERIOD_AREA_COLOR = '#F8D4D2'
